import { composePermissions } from '@/commons/permissoesGrupos';

export default [
    {
        path: '/suporte',
        name: 'suporte',
        component: () => import('@/modules/suporte/views/AjudaView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: composePermissions('ADMINISTRADOR', 'ADMIN', 'COORDENADOR' )
        },
    },
]